export class SaveWorkflowNotesParametersDto {
    workflowId: number;
    communityId: number;
    newNote: string;
}
